var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:document-download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.5 18.75L21.4395 17.6895L19.5 19.629V13.5H18V19.629L16.0605 17.6895L15 18.75L18.75 22.5L22.5 18.75Z",
    fill: "#0076BE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.5 21H6V3.00001H12V7.50001C12.0012 7.89747 12.1596 8.27831 12.4407 8.55936C12.7217 8.84041 13.1025 8.99882 13.5 9.00001H18V11.25H19.5V7.50001C19.5026 7.40144 19.4839 7.30347 19.4451 7.21284C19.4062 7.12221 19.3482 7.04107 19.275 6.97501L14.025 1.72501C13.959 1.65177 13.8778 1.59372 13.7872 1.55488C13.6966 1.51603 13.5986 1.49731 13.5 1.50001H6C5.60254 1.5012 5.2217 1.65961 4.94065 1.94066C4.6596 2.22171 4.50119 2.60255 4.5 3.00001V21C4.50119 21.3975 4.6596 21.7783 4.94065 22.0594C5.2217 22.3404 5.60254 22.4988 6 22.5H13.5V21ZM13.5 3.30001L17.7 7.50001H13.5V3.30001Z",
    fill: "#0076BE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload);
export default __webpack_public_path__ + "static/media/file-download.89004cdcd2f6384e2a7841a95167a520.svg";
export { ForwardRef as ReactComponent };